// Widget de Tawk. Dónde se muestra y en qué posición lo maneja el equipo desde
// el CRM (Settings → Chat widget); ChatWidget lo carga una sola vez y lo
// prende o apaga en cada cambio de ruta.

type Placement = { position: string; xOffset: number; yOffset: number };

export type ChatWidgetSettings = {
  pages: { key: string; paths: string[]; desktop: boolean; mobile: boolean }[];
  position: { desktop: Placement; mobile: Placement } | null;
  inApp: boolean;
};

// Si la API no responde: igual que antes de tener settings.
export const FALLBACK_SETTINGS: ChatWidgetSettings = {
  pages: [
    {
      key: 'booking-proposal',
      paths: ['/booking-proposal/*'],
      desktop: false,
      mobile: false,
    },
  ],
  position: null,
  inApp: false,
};

const matches = (path: string, pathname: string) =>
  path.endsWith('/*')
    ? pathname.startsWith(path.slice(0, -1))
    : pathname === path;

// Una página sin configurar muestra el widget.
export const isChatWidgetAllowed = (
  settings: ChatWidgetSettings,
  pathname: string,
  mobile: boolean,
  inApp: boolean
) => {
  if (inApp && !settings.inApp) return false;
  const path = pathname.replace(/\/+$/, '') || '/';
  const page = settings.pages.find((p) => p.paths.some((x) => matches(x, path)));
  return page ? page[mobile ? 'mobile' : 'desktop'] : true;
};

// La app abre checkout, FAQ, etc. con react-native-webview, que expone esto.
export const isInApp = () => Boolean((window as any).ReactNativeWebView);

export const isMobileViewport = () =>
  window.matchMedia('(max-width: 767px)').matches;

let allowed = false;
const tawk = () => ((window as any).Tawk_API ||= {});

export const hideChatWidget = () => tawk().hideWidget?.();

// Solo lo muestra si la página actual lo permite (el tour de booking lo
// oculta un rato y después llama a esto).
export const showChatWidget = () => {
  if (allowed) tawk().showWidget?.();
};

export const setChatWidgetAllowed = (value: boolean) => {
  allowed = value;
  if (value) showChatWidget();
  else hideChatWidget();
};
